export default __webpack_public_path__ + "static/media/import-icon.820fdda1.svg";